import React from 'react';
import { connect } from 'react-redux';

import { actions } from '../../../ducks/MessagePreview';
import { getDispatch } from '../../../lib/dispatchExporter';
import DiscoveryNewsBody from '../sharedUnpackeNewsComponents/DiscoveryNewsBody';
import I18n from '../../../lib/i18n';
import ListImagePreviews from '../ListImagePreviews';
import LoadingIndicator from '../LoadingIndicator';
import OunceNewsHeader from '../sharedUnpackeNewsComponents/OunceNewsHeader';
import OunceRelatedChannelList from '../sharedUnpackeNewsComponents/OunceRelatedChannelList';
import OunceRelatedProductList from '../sharedUnpackeNewsComponents/OunceRelatedProductList';

function mapStateToProps(state: any) {
  return {
    isFetching: state.$$previewStore.get('isFetching'),
    semanticsVersion: state.$$previewStore.get('semanticsVersion'),
    languagesAndIds: state.$$previewStore.get('languagesAndIds'),
    activeLanguage: state.$$previewStore.get('activeLanguage'),
    unpackedNews: state.$$previewStore.get('unpackedNews'),
    isPrintPreview: state.$$previewStore.get('isPrintPreview'),
    previewType: state.$$previewStore.get('previewType'),
  };
}

type Props = ReturnType<typeof mapStateToProps>;

export class DiscoveryUnpackedNewsView extends React.PureComponent<Props> {
  private dispatch = getDispatch();

  public componentWillMount() {
    const { languagesAndIds, activeLanguage } = this.props;
    this.dispatch(actions.fetchUnpackedNewsRequest({ message_detail_id: languagesAndIds[activeLanguage], platform: 'ounce' }));
  }

  public render() {
    const { unpackedNews, isFetching, isPrintPreview } = this.props;
    if (isFetching) {
      return <LoadingIndicator />;
    }
    if (!unpackedNews) {
      return null;
    }

    const displayClassName =
      isPrintPreview ?
      'display-box-print-preview' :
      'display-box';

    return (
      <div className="discovery-message-preview">
        <ListImagePreviews
          listImage={unpackedNews.list_image}
          subjectText={unpackedNews.subject.text}
          iconImage={unpackedNews.topic_image}
          isCaptionDisplay={unpackedNews.isCaptionDisplay()}
          movie={unpackedNews.movie}
          isDiscovery
        />
        <div className="display">
          <div className={displayClassName}>
            <div className="scroll">
              <div className="main-area">
                <div className="main-contents">
                  <OunceNewsHeader
                    newsIcon={unpackedNews.topic_image}
                    topicName={unpackedNews.topic_name}
                    publisher={unpackedNews.topic_publisher}
                  />
                  <DiscoveryNewsBody
                    subject={unpackedNews.subject.text}
                    body={unpackedNews.body}
                    more={unpackedNews.more}
                    relatedProducts={unpackedNews.related_products}
                    relatedChannel={unpackedNews.related_channels[0]}
                    relatedMovies={unpackedNews.related_movies}
                    footerText={unpackedNews.footer.text}
                    ratingInformation={unpackedNews.rating_information}
                  />
                </div>
              </div>
              <div className="side-area">
                <OunceRelatedProductList relatedProducts={unpackedNews.related_products} />
                <OunceRelatedChannelList relatedChannels={unpackedNews.related_channels} />
              </div>
            </div>
          </div>
        </div>
        <p className="hints warning">
          {I18n.t('messages.hints.only_support_chrome')}
        </p>
        <p className="hints">
          {I18n.t('messages.hints.preview_area_emulate_nx_screen_size')}
        </p>
        <p className="hints">
          {I18n.t('messages.hints.preview_area_is_scrollable')}
        </p>
        <p className="hints">
          {I18n.t('messages.hints.line_feed_position_may_not_be_accurate')}
        </p>
      </div>
    );
  }
}

export const DiscoveryUnpackedNewsViewContainer = connect(mapStateToProps)(DiscoveryUnpackedNewsView);
